export const prepareAlterStockRequest = (
  draft,
  previousRequest,
  createKey = () => crypto.randomUUID(),
) => {
  const fingerprint = JSON.stringify(draft)
  const requestState = previousRequest?.fingerprint === fingerprint
    ? previousRequest
    : { fingerprint, key: createKey() }

  return {
    requestState,
    payload: {
      ...draft,
      idempotencyKey: requestState.key,
    },
  }
}

// Before an on-hand pull is confirmed, the backend says which orders it would
// take reserved units from (stock lifecycle task 20). Other stock types are
// their own buckets and never touch a reservation.
export const prepareRemovalPreviewRequest = (draft) => {
  if (draft?.stockType !== 'on_hand') return null
  const lines = (draft.pullStock || [])
    .filter(line => line?.sku && Number(line.quantity) > 0)
    .map(line => ({ sku: line.sku, quantity: Number(line.quantity) }))
  return lines.length > 0 ? { location: draft.location, lines } : null
}

export const describeAffectedReservation = (line) => {
  const what = `${line.orderName}: ${line.quantity} x ${line.sku} reserved at ${line.from?.locationCode}`
  return line.outcome === 'moved' && line.to
    ? `${what} moves to ${line.to.locationCode}`
    : `${what} waits for stock`
}

// Who holds reserved units the planner cannot move to other stock (an order
// mid-reallocation, one outside what it plans, a reservation from before the
// ledger): the pull may not take them.
export const describeImmovableReservation = (entry) => {
  const holders = (entry?.holders || []).map(holder => `${holder.orderName} x${holder.quantity} (${holder.reason})`)
  if (entry?.unattributedUnits > 0) holders.push(`${entry.unattributedUnits} unit(s) no open line names`)
  return `${entry?.sku}: held by ${holders.join(', ') || 'no open line'}`
}

// Whether the pull takes units reserved for orders: the backend then needs the
// user's confirmation (acknowledgeReservedRemoval) while the planner is live.
export const takesReservedStock = (preview) => Boolean(
  preview?.skus?.some(sku => Number(sku.uncoveredReservedUnits) > 0),
)

// The request as sent once the user has confirmed the dialog: it acknowledges
// the reserved units the preview showed it taking.
export const withReservedRemovalAcknowledged = (payload, preview) => (
  takesReservedStock(preview) ? { ...payload, acknowledgeReservedRemoval: true } : payload
)

// A 409 asking the user to confirm a pull of reserved stock carries the
// preview, so the dialog can show it and the next confirm acknowledges it.
export const reservedRemovalPreviewFromError = (body) => (
  body?.acknowledgementRequired && body?.preview ? body.preview : null
)
